import cx from 'classnames';
import {ComponentProps, FC, useRef} from 'react';
import {Select} from '~library/atoms/Select';
import {Typography} from '~library/atoms/Typography';

interface GuestOptionPlusOnesProps {
  checked: boolean;
  dataQaId?: string;
  description: string;
  disabled?: boolean;
  heading: string;
  limitPerGuest: number;
  onChange: () => void;
  setLimitPerGuest: (value: number) => void;
}

export const GuestOptionPlusOnes: FC<GuestOptionPlusOnesProps> = ({
  heading,
  description,
  checked,
  onChange,
  dataQaId,
  disabled = false,
  limitPerGuest,
  setLimitPerGuest,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const triggerInputClick = () => {
    if (inputRef.current && inputRef.current?.tagName.toLowerCase() === 'input') {
      onChange();
    }
  };

  const handleOnChange = (value: number) => {
    const newVal = parseInt(value.toString() || '0', 10);

    const shouldBeChecked = newVal > 0;

    if (checked !== shouldBeChecked) {
      triggerInputClick();
    }

    setLimitPerGuest(newVal);
  };

  return (
    <div className="edit-flow__guest-options__option">
      <div className="edit-flow__guest-options__title">
        <Typography variant="paragraph2" color={disabled ? 'coin' : 'charcoal'}>
          {heading}
        </Typography>
        <Typography variant="paragraph3" color={disabled ? 'coin' : 'pebble'}>
          {description}
        </Typography>
        <label className={cx('input-toggle-container hidden')}>
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            ref={inputRef}
          />
          <span
            className={cx('input-toggle hidden', {disabled})}
            data-checked={checked}
            data-qa-id={dataQaId}
          />
        </label>
      </div>
      <div className="edit-flow__guest-options__limit-per-guest">
        <Select
          {...({} as ComponentProps<typeof Select>)} // Explicit type casting
          options={Array.from(new Array(10), (_, i) => ({
            label: i === 0 ? `${i}` : `+${i}`,
            value: i,
          }))}
          value={{
            label: disabled || limitPerGuest === 0 ? '0' : `+${limitPerGuest}`,
            value: disabled ? 0 : limitPerGuest,
          }}
          onChange={(value: number) => handleOnChange(value)}
          data-qa-id="limit-per-guest"
          disabled={disabled}
        />
      </div>
    </div>
  );
};
